import { render, staticRenderFns } from "./vehiclesVerticalListComponent.vue?vue&type=template&id=08594add&"
import script from "./vehiclesVerticalListComponent.vue?vue&type=script&lang=js&"
export * from "./vehiclesVerticalListComponent.vue?vue&type=script&lang=js&"
import style0 from "./vehiclesVerticalListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vehiclesVerticalListComponent.vue"
export default component.exports